import _ from 'lodash';
const proxyToInt = import.meta.env.VITE_PROXY_TO_INT === 'true';

let apiBase = proxyToInt ? 'https://int.api.muzado.com' : '';
let dynamicAssetServerRoot = proxyToInt ? 'https://int.api.muzado.com' : '';
let cookieDomain = 'localhost';

switch (import.meta.env.MODE) {
	case 'int':
        apiBase = 'https://int.api.muzado.com';
        dynamicAssetServerRoot = 'https://int.api.muzado.com';
		cookieDomain = '.muzado.com';
		break;
	case 'production':
        apiBase = 'https://api.muzado.com';
        dynamicAssetServerRoot = 'https://api.muzado.com';
		cookieDomain = '.muzado.com';
		break;
}

const config = {
	rules: {
		MAX_ARTIST_PHOTOS: 15
	},

	routes: {
		login: `${apiBase}/api/auth`,
		initial: `${apiBase}/api/initial`,
		profile: `${apiBase}/api/users/session/profile`,

		users: `${apiBase}/api/users`,
		usersPaged: `${apiBase}/api/paged/users?page=:page&limit=:limit`,
		user: `${apiBase}/api/users/:id`,
		createUser: `${apiBase}/api/users/create`,
		removeProfileImage: `${apiBase}/api/users/remove/profile-image/:id`,
		updatePassword: `${apiBase}/api/users/password/:id`,
		checkEmail: `${apiBase}/api/users/check-email/:email`,

		createArtist: `${apiBase}/api/artists/create`,
		createAlbum: `${apiBase}/api/albums/create`,
		artists: `${apiBase}/api/artists`,
		artist: `${apiBase}/api/artists/:id`,
		deleteArtist: `${apiBase}/api/artists/remove/:id`,

		playlists: `${apiBase}/api/playlists`,
		playlist: `${apiBase}/api/playlists/:id`,
		playlistCreate: `${apiBase}/api/playlists/create`,
		playlistRemove: `${apiBase}/api/playlists/remove/:id`,
		playlistArtworkUpload: `${apiBase}/api/playlists/upload/artwork/:id`,

		documents: `${apiBase}/api/documents`,
		documentCreate: `${apiBase}/api/documents`,
		document: `${apiBase}/api/documents/:id`,

		albums: `${apiBase}/api/albums`,
		album: `${apiBase}/api/albums/:id`,
		songs: `${apiBase}/api/songs`,
		song: `${apiBase}/api/songs/:id`,

		genres: `${apiBase}/api/genres`,
		genreCreate: `${apiBase}/api/genres/create`,
		genreRemove: `${apiBase}/api/genres/remove/:id`,
		genreArtworkUpload: `${apiBase}/api/genres/upload/artwork/:id`,

		subscription: `${apiBase}/api/subscriptions`,
		hiFive: `${apiBase}/api/hi-fives`,

		deleteSong: `${apiBase}/api/songs/remove/:id`,
		delete: `${apiBase}/api/:collection/:id`,
		albumssyArtist: `${apiBase}/api/albums/artist/:artistID`,
		songsByArtist: `${apiBase}/api/songs/artist/:artistID`,
		profileImageUpload: `${apiBase}/api/profile-image/upload/:id`,
		artistPhotoUpload: `${apiBase}/api/artist-photo/upload/:id`,
		albumArtworkUpload: `${apiBase}/api/albums/upload/artwork/:id`,
		searchGenres: `${apiBase}/api/genres/search/:search`,
		songUpload: `${apiBase}/api/songs/upload/:id`,
		songFullPreviewPosition: `${apiBase}/api/songs/full-preview-position/:id`,
		songFullPreviewRemove: `${apiBase}/api/songs/full-preview-remove/:id`
	},

	paths: {
		stripeRegister: 'https://dashboard.stripe.com/register',
		songBasePath: `${dynamicAssetServerRoot}/assets/public/s3/song`,
		imgBasePath: '/assets/public/s3/img',
		profileImgBasePath: `${dynamicAssetServerRoot}/assets/public/s3/img`,
		bannerImgBasePath: `${dynamicAssetServerRoot}/assets/public/s3/img`,

		admin: {
			submissionsHomePath: '#/submissions',
			submissionsArtistPath: '#/submissions/artist/:id'
		}
	},

	fb: {
		appID: '1472223746211834'
	},

	services: {
		api: 'https://hfm-api:3000',
		auth: 'https://hfm-auth:3000/api/auth',
		authCheck: 'https://hfm-auth:3000/api/auth/check',
		authTerm: 'https://hfm-auth:3000/api/auth/terminate',
		users: 'https://hfm-api:3000/api/users',
		artists: 'https://hfm-api:3000/api/artists',
		profile: 'https://hfm-api:3000/api/user/profile/:id'
	}
};

const getRoute = (key, id = null) => {
	const route = config.routes[key];

	if (_.isNull(id) || _.isEmpty(route)) {

		return route;
	}

	return route.replace(/\:id/, id);
}

export default {
	...config,
	getRoute
};
